import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { ClienteCentralCompra } from '../cliente-central-compra';

@Injectable({
    providedIn: 'root'
})
export class ClienteCentralCompraHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clientecentralcompra`;
    }


    /** Carrega a central de compras */
    load(id: number): Observable<ClienteCentralCompra> {
        return this.customHttp.get<ClienteCentralCompra>(`${this.pathApi}/${id}`);
    }

    /** Salva a central de compras */
    save(entity: ClienteCentralCompra): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/${entity?.id}`, entity);
    }
}
